// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/featurama/model.proto
/* eslint-disable */
import * as _m0 from "protobufjs/minimal.js";
import { Feature } from "../sub2/data.js";
import { ActivationStatus, FeatureSetKey } from "./feature_sets.js";
// For Node.js to access named exports from CommonJS
const __m0 = 'default' in _m0 ? _m0.default : _m0;
export const protobufPackage = "squareup.featurama.model";
function createBaseFeatureStatusForSeller() {
    return {
        $type: "squareup.featurama.model.FeatureStatusForSeller",
        key: undefined,
        subscriptionStatus: undefined,
        activationStatus: undefined,
    };
}
export const FeatureStatusForSeller = {
    $type: "squareup.featurama.model.FeatureStatusForSeller",
    encode(message, writer = __m0.Writer.create()) {
        if (message.key !== undefined) {
            writer.uint32(8).int32(message.key);
        }
        if (message.subscriptionStatus !== undefined) {
            FeatureSubscriptionStatusForSeller.encode(message.subscriptionStatus, writer.uint32(18).fork()).ldelim();
        }
        if (message.activationStatus !== undefined) {
            FeatureSetActivationStatusForSeller.encode(message.activationStatus, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureStatusForSeller();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.key = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subscriptionStatus = FeatureSubscriptionStatusForSeller.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.activationStatus = FeatureSetActivationStatusForSeller.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeatureStatusForSeller.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureStatusForSeller();
        message.key = object.key ?? undefined;
        message.subscriptionStatus = (object.subscriptionStatus !== undefined && object.subscriptionStatus !== null)
            ? FeatureSubscriptionStatusForSeller.fromPartial(object.subscriptionStatus)
            : undefined;
        message.activationStatus = (object.activationStatus !== undefined && object.activationStatus !== null)
            ? FeatureSetActivationStatusForSeller.fromPartial(object.activationStatus)
            : undefined;
        return message;
    },
};
function createBaseFeatureSubscriptionStatusForSeller() {
    return {
        $type: "squareup.featurama.model.FeatureSubscriptionStatusForSeller",
        isEntitled: undefined,
        isInTrial: undefined,
        metadata: undefined,
    };
}
export const FeatureSubscriptionStatusForSeller = {
    $type: "squareup.featurama.model.FeatureSubscriptionStatusForSeller",
    encode(message, writer = __m0.Writer.create()) {
        if (message.isEntitled !== undefined) {
            writer.uint32(8).bool(message.isEntitled);
        }
        if (message.isInTrial !== undefined) {
            writer.uint32(16).bool(message.isInTrial);
        }
        if (message.metadata !== undefined) {
            FeatureSubscriptionStatusMetadata.encode(message.metadata, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureSubscriptionStatusForSeller();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isEntitled = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isInTrial = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.metadata = FeatureSubscriptionStatusMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeatureSubscriptionStatusForSeller.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureSubscriptionStatusForSeller();
        message.isEntitled = object.isEntitled ?? undefined;
        message.isInTrial = object.isInTrial ?? undefined;
        message.metadata = (object.metadata !== undefined && object.metadata !== null)
            ? FeatureSubscriptionStatusMetadata.fromPartial(object.metadata)
            : undefined;
        return message;
    },
};
function createBaseFeatureSubscriptionStatusMetadata() {
    return {
        $type: "squareup.featurama.model.FeatureSubscriptionStatusMetadata",
        entitledThroughPlanTokens: [],
        recommendedUpgradeTierToken: undefined,
    };
}
export const FeatureSubscriptionStatusMetadata = {
    $type: "squareup.featurama.model.FeatureSubscriptionStatusMetadata",
    encode(message, writer = __m0.Writer.create()) {
        for (const v of message.entitledThroughPlanTokens) {
            writer.uint32(10).string(v);
        }
        if (message.recommendedUpgradeTierToken !== undefined) {
            writer.uint32(18).string(message.recommendedUpgradeTierToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureSubscriptionStatusMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.entitledThroughPlanTokens.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.recommendedUpgradeTierToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeatureSubscriptionStatusMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureSubscriptionStatusMetadata();
        message.entitledThroughPlanTokens = object.entitledThroughPlanTokens?.map((e) => e) || [];
        message.recommendedUpgradeTierToken = object.recommendedUpgradeTierToken ?? undefined;
        return message;
    },
};
function createBaseFeatureSetStatusForSeller() {
    return {
        $type: "squareup.featurama.model.FeatureSetStatusForSeller",
        featureSetKey: undefined,
        activationStatus: undefined,
    };
}
export const FeatureSetStatusForSeller = {
    $type: "squareup.featurama.model.FeatureSetStatusForSeller",
    encode(message, writer = __m0.Writer.create()) {
        if (message.featureSetKey !== undefined) {
            writer.uint32(8).int32(message.featureSetKey);
        }
        if (message.activationStatus !== undefined) {
            FeatureSetActivationStatusForSeller.encode(message.activationStatus, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureSetStatusForSeller();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.featureSetKey = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.activationStatus = FeatureSetActivationStatusForSeller.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeatureSetStatusForSeller.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureSetStatusForSeller();
        message.featureSetKey = object.featureSetKey ?? undefined;
        message.activationStatus = (object.activationStatus !== undefined && object.activationStatus !== null)
            ? FeatureSetActivationStatusForSeller.fromPartial(object.activationStatus)
            : undefined;
        return message;
    },
};
function createBaseFeatureSetActivationStatusForSeller() {
    return {
        $type: "squareup.featurama.model.FeatureSetActivationStatusForSeller",
        activationStatus: undefined,
        isActive: undefined,
    };
}
export const FeatureSetActivationStatusForSeller = {
    $type: "squareup.featurama.model.FeatureSetActivationStatusForSeller",
    encode(message, writer = __m0.Writer.create()) {
        if (message.activationStatus !== undefined) {
            writer.uint32(8).int32(message.activationStatus);
        }
        if (message.isActive !== undefined) {
            writer.uint32(16).bool(message.isActive);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof __m0.Reader ? input : __m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureSetActivationStatusForSeller();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.activationStatus = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isActive = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return FeatureSetActivationStatusForSeller.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeatureSetActivationStatusForSeller();
        message.activationStatus = object.activationStatus ?? undefined;
        message.isActive = object.isActive ?? undefined;
        return message;
    },
};
